import {getMyMatches, fetchNextCall} from 'app/services/myMatches';
import {catchDataError, parseLinkHeader} from 'app/helpers/apiHelpers';

const updateMyMatches = data => {
  return {
    type: 'MY_MATCHES_UPDATE',
    data,
  };
};

const errorMyMatches = data => {
  return {
    type: 'MY_MATCHES_ERROR',
    data,
  };
};

const fetchingMyMatches = () => {
  return {
    type: 'MY_MATCHES_FETCHING',
  };
};

const overwriteMyMatches = data => {
  return {
    type: 'MY_MATCHES_OVERWRITE',
    data,
  };
};

const fetchMyMatches = (dir, reloading) => {
  return function(dispatch, {items, nextUrl, isFetching}) {
    if ((!reloading && items.length) || isFetching || nextUrl === null) {
      return;
    }

    const fetchFunc = nextUrl ? fetchNextCall(nextUrl) : getMyMatches(dir);

    dispatch(fetchingMyMatches());
    return fetchFunc
      .then(response => {
        const meta = parseLinkHeader(response.headers.link);
        const nextUrl = meta.next ? meta.next : null;
        dispatch(updateMyMatches({items: response.data, nextUrl}));
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(errorMyMatches(errorData));
      });
  };
};

export {fetchMyMatches, overwriteMyMatches};
